const MODULE = {
  state: {
    socket: null,
    chatLog: [],
    notificationLog: []
  },

  mutations: {
    setEventSocket (state, socket) {
      if (state.socket !== null) {
        state.socket.close()
      }

      state.socket = socket
    },

    setChatLog (state, chatHistory) {
      state.chatLog = chatHistory
    },

    setNotificationLog (state, notificationHistory) {
      state.notificationLog = notificationHistory
    },

    addChat (state, chat) {
      state.chatLog.push(chat)
    },

    addNotification (state, notification) {
      state.notificationLog.push(notification)
    }
  },

  actions: {
    setupEventSocket: async (context, token) => {
      var queryParams = {
        auth: token
      }
      queryParams = new URLSearchParams(queryParams).toString()
      queryParams = '?' + queryParams

      const url = process.env.VUE_APP_WS_BASE + '/rt/event' + queryParams
      context.commit('setEventSocket', new WebSocket(url))
      context.state.socket.onmessage = (event) => context.dispatch('processMessage', event.data)
      console.log('EVENT SOCKET CREATED')
    },

    processMessage: async (context, messageString) => {
      const messageJSON = JSON.parse(messageString)
      console.log(messageJSON)
      if (messageJSON.type === 'chat') {
        context.commit('addChat', messageJSON)
      } else if (messageJSON.type === 'notification') {
        context.commit('addNotification', messageJSON)
        if (messageJSON.payload.includes('dotted a thought')) {
          await context.dispatch('canvas/requestAllThoughts', null, { root: true })
        } else if (messageJSON.payload.includes('public thought')) {
          context.commit('setTabBadgeNumber', {
            drawerName: 'whiteboard',
            tabName: 'thoughtCatcherTab',
            badgeNumber: context.rootState.tabs.whiteboard.thoughtCatcherTab.badgeNumber + 1
          }, { root: true })
        } else if (messageJSON.payload.includes('how might we')) {
          context.commit('setTabBadgeNumber', {
            drawerName: 'whiteboard',
            tabName: 'parkingLotTab',
            badgeNumber: context.rootState.tabs.whiteboard.parkingLotTab.badgeNumber + 1
          }, { root: true })
        } else if (messageJSON.payload.includes('fact')) {
          context.commit('setTabBadgeNumber', {
            drawerName: 'whiteboard',
            tabName: 'factsTab',
            badgeNumber: context.rootState.tabs.whiteboard.factsTab.badgeNumber + 1
          }, { root: true })
        }
      } else if ((messageJSON.type === 'refreshThought')) {
        await context.dispatch('canvas/requestAllThoughts', null, { root: true })
        console.log(context.rootState.canvas.thoughtCatcher)
      } else if (messageJSON.type === 'refreshHMW') {
        await context.dispatch('canvas/requestAllHMWs', null, { root: true })
        console.log(context.rootState.canvas.HMW)
      } else if (messageJSON.type === 'refreshFact') {
        await context.dispatch('canvas/requestAllFacts', null, { root: true })
        console.log(context.rootState.canvas.facts)
      } else if (messageJSON.type === 'refreshChallenge') {
        context.dispatch('requestAllChallenges', null, { root: true })
        console.log(context.rootState.challenge)
      } else if (messageJSON.type === 'refreshParticipants') {
        console.log(messageJSON)
        context.dispatch('canvas/eventSetParticipants', messageJSON.participants)
      }
    },

    requestChatHistory: async (context) => {
      const endpoint = '/api/v1/chat'
      const queryParams = {
        challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
        size: 99
      }

      const chatHistory = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: endpoint,
        queryParams: queryParams
      })

      console.log(chatHistory)

      context.commit('setChatLog', chatHistory.messages)
    },

    requestNotificationHistory: async (context) => {
      const endpoint = '/api/v1/notification'
      const queryParams = {
        challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
        size: 99
      }

      let notificationHistory = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: endpoint,
        queryParams: queryParams
      })

      if (notificationHistory.success === false) {
        console.warning('Did not recieve notification history')
        notificationHistory = { notifications: [] }
      }

      context.commit('setNotificationLog', notificationHistory.notifications)
    },

    sendChatMessage: (context, text) => {
      var message = {
        time: new Date().toISOString(),
        type: 'chat',
        sender: context.rootState.auth.userInfo.account.uuid,
        payload: text
      }

      // stringified because that's how the message is sent from the backend
      message = JSON.stringify(message)

      // fire everyone else's 'processMessage'
      context.state.socket.send(message)

      // make visible to self
      context.dispatch('processMessage', message)
    },

    sendNotificationMessage: (context, text) => {
      var message = {
        time: new Date().toISOString(),
        type: 'notification',
        sender: context.rootState.auth.userInfo.account.uuid,
        payload: text
      }

      // stringified because that's how the message is sent from the backend
      message = JSON.stringify(message)

      // fire everyone else's 'processMessage'
      context.state.socket.send(message)

      // make visible to self
      context.dispatch('processMessage', message)
    }
  }
}

export default MODULE
